// Static interface copy. CMS content keeps its own language selection.
export const staticTranslations: Record<string, [string, string]> = {
  'Teste os seus conhecimentos': ['Test your knowledge', 'Testa ls tous cunhecimientos'],
  'Imagem anterior': ['Previous image', 'Eimaige anterior'],
  'Imagem seguinte': ['Next image', 'Eimaige seguinte'],
  'Ver imagem': ['View image', 'Ber eimaige'],
  'Iniciar Quiz': ['Start quiz', 'Aniciar quiz'],
  'Sair': ['Exit', 'Salir'],
  'Tempo Restante': ['Time remaining', 'Tiempo restante'],
  'Responder': ['Submit answer', 'Responder'],
  'Continuar': ['Continue', 'Continuar'],
  'Jogar novamente': ['Play again', 'Jogar outra beç'],
  'A sua pontuação': ['Your score', 'La tua pontuaçon'],
  'Sair do questionário?': ['Exit the quiz?', 'Salir de l questionário?'],
  'Continuar a jogar': ['Keep playing', 'Continuar a jogar'],
  'Sim, sair': ['Yes, exit', 'Si, salir'],
  'Escreva a sua resposta': ['Type your answer', 'Scribe la tua repuosta'],
  'O seu progresso não será guardado e vai voltar ao menu principal.': ['Your progress will not be saved and you will return to the main menu.', 'L tou progresso nun será guardado i tornarás al menu principal.'],
  'Tempo esgotado!': ["Time’s up!", 'Tiempo sgotado!'],
  'Já lá vai o tempo!': ['You have run out of time!', 'L tiempo yá acabou!'],
  'Já lá vai o tempo! Continue para concluir o quiz.': ['You have run out of time! Continue to finish the quiz.', 'L tiempo yá acabou! Continua para acabar l quiz.'],
  'Certo!': ['Correct!', 'Cierto!'],
  'Não é bem assim.': ['Not quite right.', 'Nun ye bien assi.'],
  'Categoria': ['Category', 'Categorie'],
  'A carregar…': ['Loading…', 'A carregar…'],
  'A carregar quiz…': ['Loading quiz…', 'A carregar l quiz…'],
  'Não foi possível carregar este quiz.': ['This quiz could not be loaded.', 'Nun fui possible carregar este quiz.'],
  'Não foi possível carregar o quiz.': ['The quiz could not be loaded.', 'Nun fui possible carregar l quiz.'],
  'Não foi possível carregar o ecrã.': ['The screen could not be loaded.', 'Nun fui possible carregar l ecran.'],
  'O workspace não tem domínio público configurado.': ['No public domain is configured for this workspace.', 'L workspace nun ten un domínio público cunfigurado.'],
  'Início': ['Home', 'Anício'],
  'Voltar': ['Back', 'Tornar'],
  'Ver vídeo': ['Watch video', 'Ber bídeo'],
  'Fechar vídeo': ['Close video', 'Cerrar bídeo'],
  'vídeo': ['video', 'bídeo'],
  'Fechar': ['Close', 'Cerrar'],
  'Créditos e Bibliografia': ['Credits and Bibliography', 'Créditos i Bibliografie'],
  'Créditos e bibliografia': ['Credits and bibliography', 'Créditos i bibliografie'],
  'Textos': ['Texts', 'Testos'],
  'Fotografias': ['Photographs', 'Fotografies'],
  'Atualização da cache': ['Cache update', 'Atualizaçon de la cache'],
  'Última atualização': ['Last update', 'Última atualizaçon'],
  'Ainda não existe uma atualização registada neste dispositivo.': ['No update has been recorded on this device yet.', 'Inda nun hai ua atualizaçon registrada neste dispositivo.'],
  'A atualizar…': ['Updating…', 'A atualizar…'],
  'Forçar atualização integral': ['Force full update', 'Forçar atualizaçon cumpleta'],
  'Rede: ligada': ['Network: connected', 'Rede: ligada'],
  'Rede: desligada': ['Network: disconnected', 'Rede: desligada'],
  'Falhas da última sincronização': ['Last sync failures', 'Falhas de la última sincronizaçon'],
  'Ligue o dispositivo à rede para atualizar.': ['Connect the device to the network to update.', 'Liga l dispositivo a la rede para atualizar.'],
  'Cache offline por verificar': ['Offline cache not yet checked', 'Cache offline por berificar'],
  'A preparar o armazenamento offline': ['Preparing offline storage', 'A preparar l armazenamento offline'],
  'Textos, categorias e conteúdos descarregados': ['Texts, categories and content downloaded', 'Testos, categories i cuntenidos descargados'],
  'Falha ao verificar gravação': ['Failed to verify saved data', 'Falha al berificar la gravaçon'],
  'Atualização incompleta; verifique a ligação.': ['Update incomplete; check the connection.', 'Atualizaçon incumpleta; berifica la ligaçon.'],
  'A iniciar a atualização integral': ['Starting full update', 'A aniciar la atualizaçon cumpleta'],
  'Não foi possível iniciar a atualização.': ['The update could not be started.', 'Nun fui possible aniciar la atualizaçon.'],
  'Falha ao atualizar a cache offline.': ['Failed to update the offline cache.', 'Falha al atualizar la cache offline.'],
  'falha ao descarregar': ['download failed', 'falha al descargar'],
  'falha ao guardar': ['save failed', 'falha al guardar'],
  'falha ao guardar dados': ['failed to save data', 'falha al guardar dados'],
  'IndexedDB indisponível neste navegador.': ['IndexedDB is unavailable in this browser.', 'IndexedDB nun stá disponible neste nabegador.'],
  'Gravação offline interrompida.': ['Offline save interrupted.', 'Gravaçon offline anterrompida.'],
};

// Translate at render time so stored feedback/progress follows language changes.
export const translateStatic = (text: string, language: string): string => {
  const index = language === 'en-GB' ? 0 : language === 'mwl-PT' ? 1 : -1;
  if (index < 0 || !text) return text;
  if (staticTranslations[text]) return staticTranslations[text][index];
  const patterns: [RegExp, [string, string]][] = [
    [/^A guardar recursos offline: (\d+) de (\d+)$/, ['Saving offline resources: $1 of $2', 'A guardar recursos offline: $1 de $2']],
    [/^Cache offline concluída \((\d+) recursos\)$/, ['Offline cache complete ($1 resources)', 'Cache offline cumpleta ($1 recursos)']],
    [/^Atualização incompleta: (\d+) falhas$/, ['Update incomplete: $1 failures', 'Atualizaçon incumpleta: $1 falhas']],
    [/^Não foi possível carregar o workspace \((\d+)\)\.$/, ['The workspace could not be loaded ($1).', 'Nun fui possible carregar l workspace ($1).']],
    [/^Não foi possível carregar os conteúdos \((\d+)\)\.$/, ['Content could not be loaded ($1).', 'Nun fui possible carregar ls cuntenidos ($1).']],
    [/^Não foi possível submeter a resposta \((\d+)\)\.$/, ['The answer could not be submitted ($1).', 'Nun fui possible anbiar la repuosta ($1).']],
    [/^Resposta inválida em (.+)$/, ['Invalid response at $1', 'Repuosta ambálida an $1']],
    [/^Paginação excedeu o limite em (.+)$/, ['Pagination limit exceeded at $1', 'La paginaçon passou l limite an $1']],
  ];
  for (const [pattern, translations] of patterns) {
    if (pattern.test(text)) return text.replace(pattern, translations[index]);
  }
  // Feedback may combine a static timeout with an explanation from the CMS.
  for (const key of Object.keys(staticTranslations).sort((a, b) => b.length - a.length)) {
    if (text.startsWith(`${key} `)) return staticTranslations[key][index] + text.slice(key.length);
    if (text.endsWith(`: ${key}`)) return text.slice(0, -key.length) + staticTranslations[key][index];
  }
  return text;
};
